import { module } from 'modujs';

const PATH = {
    blogs: '/blogs',
    search: '/search',
    listCollections: '/collections',
    listCollectionsProduct: '/products',
    cart: '/cart'
}

export default class extends module {
    constructor(m) {
        super(m);

        this.requestPath = this.getData('request-path') || false;
        this.shopUrl = this.getData('shop-url') || false;
    }

    init() {
        this.redirect()
    }

    redirect(url = this.shopUrl) {
        if(
            this.requestPath.includes(PATH.search) ||
            this.requestPath.includes(PATH.cart) ||
            this.requestPath.includes(PATH.blogs) ||
            this.requestPath == PATH.listCollections ||
            this.requestPath == PATH.listCollectionsProduct
        ) {
            window.location.href = url
        }
    }

    destroy() {
        super.destroy()
    }
}
